import { render, staticRenderFns } from "./RsaSchedaInfermieristicaValutazionePreferenzeEditComponent.vue?vue&type=template&id=48fdf93c"
import script from "./RsaSchedaInfermieristicaValutazionePreferenzeEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaValutazionePreferenzeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports